/** @jsx jsx */
import { Flex, Link, Text, Title } from '@bottlebooks/gatsby-theme-base';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import getUrlFromPageReference from '../../helpers/getUrlFromPageReference';

export default function MenuItemBlock({ title, menuItems, ...rest }) {
  return (
    <Flex direction="column" gap={2} {...rest}>
      {title && (
        <Title variant="small" sx={{ marginBottom: 2 }}>
          {title}
        </Title>
      )}
      {menuItems.map((menuItem) => {
        const url = getUrlFromPageReference(menuItem.page);
        return (
          <Link key={menuItem._key} to={url}>
            <Text variant="large">{menuItem.name}</Text>
          </Link>
        );
      })}
    </Flex>
  );
}

export const fragment = graphql`
  fragment SanityMenuItemBlockFragment on SanityMenuItemBlock {
    title
    menuItems {
      _key
      name
      page {
        ...SanityPageReference
      }
    }
  }
`;
